import React, { useCallback, useEffect, useState } from 'react'
import DescricaoDoProjetoOuInvestimento from '../StepPreenchimentoDaSolicitacao/DescricaoDoProjetoOuInvestimento'
import MotivadorDoCapexNaoPrevisto from '../StepPreenchimentoDaSolicitacao/MotivadorDoCapexNaoPrevisto'
import Detalhes from '../StepPreenchimentoDaSolicitacao/Detalhes'
import Orcamento from '../StepPreenchimentoDaSolicitacao/Orcamento'
import RecursosParaExecucao from '../StepPreenchimentoDaSolicitacao/RecursosParaExecucao'
import ValidacoesAprovacoes from '../StepPreenchimentoDaSolicitacao/ValidacoesAprovacoes'
import { Visibility } from '@app/components/Visibility'
import { hasPermission } from '@app/helpers/permissions'
import VincularAoProjeto from '../StepVincularAoProjeto/VincularAoProjeto'
import OrcamentoFinanceiro from '../StepPreenchimentoDaSolicitacao/OrcamentoFinanceiro'
import { getOrcamentoSolicitacaoNaoPrevisto, OrcamentoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao'
import { useRecoilValue } from 'recoil'
import { solicitacaoIdState } from '../../../atoms'
import { getAllAcronimosPacote } from '@app/api/acronimosPacote'
import { getAllCrfContaContabil } from '@app/api/crf/contaContabil'

const StepFinalizado = () => {
    const idSolicitacao = useRecoilValue(solicitacaoIdState)
    const [list, setList] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
    const [orcamentos, setOrcamentos] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
    const [acronimos, setAcronimos] = useState([])
    const [contasContabil, setContasContabil] = useState([])

    const loadOrcamentoData = useCallback(() => {
        if (idSolicitacao === undefined) return
        getOrcamentoSolicitacaoNaoPrevisto(idSolicitacao).then((response) => {
            if (response) {
                const newOrcamentoList = response.map((item) => ({ ...item }))
                setList([...response])
                setOrcamentos(newOrcamentoList)
            }
        })
        getAllAcronimosPacote().then((response) => {
            if (response) setAcronimos(response)
        })
        getAllCrfContaContabil().then((response) => {
            if (response) setContasContabil(response)
        })
    }, [idSolicitacao])

    useEffect(() => {
        loadOrcamentoData()
    }, [loadOrcamentoData])

    return (
        <div spellCheck={true}>
            <DescricaoDoProjetoOuInvestimento />
            <MotivadorDoCapexNaoPrevisto />
            <Detalhes />
            <Orcamento list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} />
            <OrcamentoFinanceiro list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} />
            <RecursosParaExecucao />
            <ValidacoesAprovacoes />
            <Visibility visible={hasPermission(['NAO_PREVISTO_ADMINISTRADOR'])} >
                <VincularAoProjeto />
            </Visibility>
        </div>
    )
}

export default StepFinalizado